import Button from "@mui/material/Button";
import { colors } from "../../constants/colors";

const RedButton = ({ title, onClick, style, type, disabled, icon }) => {
  return (
    <Button
      className="red_button"
      variant="contained"
      color="primary"
      disabled={disabled || false}
      onClick={onClick}
      style={{ ...style }}
      type={type}
      sx={{
        "& .MuiButton-containedPrimary": {
          backgroundColor: colors.red,
        },
      }}
    >
      {icon}
      {title}
    </Button>
  );
};

export default RedButton;
